import React from 'react'
import styled from 'styled-components'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl'
import {Sms} from '@mui/icons-material'
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu'
import Dialog from 'components/Dialog'
import SmsTemplate from 'components/SmsTemplate'
import {getSmsTemplates} from 'utils/utils'
import {
    createSmsTemplate,
    updateSmsTemplate,
    deleteSmsTemplate,
    sendSmsTemplate,
    getSmsTemplate,
    resetSmsTemplate,
    setSmsTemplatesOrder
} from 'modules/sms/actions'
import {fieldtype} from 'utils/enums/fieldtype'
import DraggableList from 'components/DraggableList'

const List = styled(MenuItem)`
	font-size: 14px;
	line-height: normal;

	&:hover {
		color: #ffc300;
        background-color: rgba(22, 22, 27, 1);
	}
`

class SmsContent extends React.Component {
    constructor(props) {
        super(props)

        this.templates = getSmsTemplates(this.props.entity)
        this.emission = null
        this.template = null
        this.order = []

        this.state = {
            openDialog: false
        }
    }

    componentDidUpdate(props) {
        if (this.props.template) {
            this.template = {...this.props.template}
            this.props.resetSmsTemplate()
            this.handleOpenDialog()
        }

        if (!this.props.test && this.props.successes && !this.props.errors) {
            this.handleCloseDialog()
        }
    }

    handleOpenDialog = () => {
        this.setState({
            openDialog: true
        })
    }

    handleCloseDialog = () => {
        this.emission = null
        this.template = null

        this.setState({
            openDialog: false
        }, () => this.props.handleClose())
    }

    selectTemplate = (e) => {
        const id = Number(e.currentTarget.getAttribute('data-list-item-id'))
        const template = this.templates.find(item => item.id === id)
        this.emission = this.props.emissions.find(item => item.id === template.emissionPath.join(','))

        this.props.getSmsTemplate(id)
    }

    selectEmission = (e) => {
        this.emission = this.props.emissions.find(item => item.id === e.currentTarget.getAttribute('data-id'))
        this.handleOpenDialog()
    }

    sendSmsTemplate = (template, save, test) => {
        this.props.sendSmsTemplate(template, this.props.documents, save, test)
    }

    onReorder = (order, id) => {
        const index = this.order.findIndex(item => item.emission === id)
        this.order[index].templates = [...order]
        const data = this.order.reduce((acc, item) => acc.concat(item.templates), [])
        this.props.setSmsTemplatesOrder(this.props.entity, data)

    }

    render() {
        const {intl, emissions} = this.props

        return (
            <React.Fragment>
                <Menu
                    anchorEl={this.props.anchorEl}
                    open={!this.state.openDialog}
                    onClose={this.props.handleClose}
                    PaperProps={{
						sx: {
							background: '#333340',
							color: 'rgba(255, 255, 255, .7)',
							borderRadius: 0
						}
					}}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    {emissions.map(item => {
                        const templates = this.templates.filter(template => template.emissionPath.join(',') === item.id)
                        this.order.push({emission: item.id, templates: templates.map(el => el.id)})

                        return <div key={item.id}>
                            <List data-id={item.id}
                                onClick={this.selectEmission} disableRipple
                            >
                                <Sms sx={{marginRight: '10px', fontSize: '18px'}} />
                                {intl.formatMessage({id: "sidebar.send_to"}, {name: '', to: item.pathName})}
                            </List>
                            <DraggableList
                                data={templates}
                                onClick={this.selectTemplate}
                                onReorder={(order) => this.onReorder(order, item.id)}
                            />
                        </div>
                    })}
                </Menu>
                {this.state.openDialog &&
                    <Dialog
                        fullWidth={true}
                        maxWidth='md'
                        open={this.state.openDialog}
                        onClose={this.handleCloseDialog}
                        disablePortal
                    >
                        <SmsTemplate
                            test={this.props.test}
                            sending={!!this.props.documents.length}
                            entity={this.props.entity}
                            name={this.props.name}
                            handleClose={this.handleCloseDialog}
                            handleReset={this.props.resetSmsTemplate}
                            emission={this.emission}
                            template={this.template}
                            createSmsTemplate={this.props.createSmsTemplate}
                            deleteSmsTemplate={this.props.deleteSmsTemplate}
                            updateSmsTemplate={this.props.updateSmsTemplate}
                            sendSmsTemplate={this.sendSmsTemplate}
                            successes={this.props.successes}
                            errors={this.props.errors}
                            fields={this.props.entities.find(item =>
                                item.id === this.props.entity).fields.filter(field =>
                                    field.uiType === fieldtype.check)}
                        />
                    </Dialog>
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({sms, entities}) => ({
    template: sms.template,
    entities: entities.entities,
    test: sms.test
})

export default connect(mapStateToProps, {
    createSmsTemplate,
    updateSmsTemplate,
    deleteSmsTemplate,
    sendSmsTemplate,
    getSmsTemplate,
    resetSmsTemplate,
    setSmsTemplatesOrder
})(injectIntl(SmsContent))
